import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Payout } from '../../models/dashboard';
import { ShellComponent } from '../../ui/shell.component';
import { AdminEventScreen } from './admin-event-screen';

@Component({
  selector: 'app-admin-event-payouts',
  standalone: true,
  imports: [ShellComponent],
  templateUrl: './admin-event-payouts.component.html',
})
export class AdminEventPayoutsComponent extends AdminEventScreen implements OnInit {
  private router = inject(Router);

  async ngOnInit(): Promise<void> {
    await this.load();
  }

  get pot(): number {
    if (!this.dashboard) return 0;
    const event = this.dashboard.event;
    return this.dashboard.registrations.reduce((total, player) => {
      let amount = event.entryFee;
      if (player.ctpEntered) amount += event.ctpEntryFee;
      if (player.longDriveEntered) amount += event.longDriveEntryFee;
      return total + amount;
    }, 0);
  }

  get paidOut(): number {
    return (this.dashboard?.payouts ?? []).reduce((total, payout) => total + payout.amount, 0);
  }

  label(payout: Payout): string {
    if (payout.description) return payout.description;
    if (payout.place) return `Place ${payout.place}`;
    return 'Payout';
  }

  winner(payout: Payout): string {
    if (payout.userId) {
      const player = this.dashboard?.registrations.find(item => item.userId === payout.userId);
      if (player) return player.displayName;
    }
    if (payout.teamId) {
      const team = this.dashboard?.teams.find(item => item.teamId === payout.teamId);
      if (team) return team.name;
    }
    return 'Unassigned';
  }

  async remove(id: number): Promise<void> {
    await this.run(() => this.api.delete('payout', { id }));
  }

  add(): void {
    void this.router.navigate(['/admin/events', this.eventId, 'payouts', 'new']);
  }
}
